exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slim-card {\n  padding-top: 16px !important;\n  padding-bottom: 16px !important;\n}\n.automation-overview-component .automation-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(800px, 1fr));\n  gap: 16px;\n  row-gap: 16px;\n}\n.automation-card .automation-card-content {\n  background-color: #e9f1fb;\n  padding: 16px;\n  border-radius: 8px;\n}\n.automation-card .automation-card-content p {\n  margin: 0 !important;\n  font-size: 15px !important;\n}", ""]);

// exports
